import { RootState } from '../rootReducer'
import { Location } from '../../lib/interfaces/Location.interface'

const get = require('lodash/get')
const find = require('lodash/find')

export const getLocations = (state: RootState): Location[] | undefined => get(state, 'app.locations')

export const getLocationWithId = (state: RootState) => (locationId: number) => {
  const locations = getLocations(state)

  return find(locations, { id: locationId })
}



// WEBPACK FOOTER //
// ./src/store/app/selectors.ts